import { callbackLogin } from "@/api/system/auth";
import { getToken, setToken, removeToken } from "@/utils/auth";

const getDefaultState = () => {
	return {
		token: getToken(),
		userName: '',
		realName: ''
	};
};

const state = getDefaultState();

const mutations = {
	RESET_STATE: state => {
		Object.assign(state, getDefaultState());
	},
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_USERNAME: (state, userName) => {
		state.userName = userName;
	},
	SET_REALNAME: (state, realName) => {
		state.realName = realName;
	}
};

const actions = {
	// callbackLogin
	callbackLogin({ commit }, data) {
		const { tokenTypeCode, wxCode } = data;
		return new Promise((resolve, reject) => {
			callbackLogin({
					tokenTypeCode: tokenTypeCode,
					wxCode: wxCode
				})
				.then(response => {
					const { data } = response;
					if (null != data) {
						commit("SET_TOKEN", data.token);
						commit("SET_USERNAME", data.userName);
						commit("SET_REALNAME", data.realName);
						setToken(data.token);
					}
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};